module.exports = __webpack_public_path__ + "img/website.2a4b439c.png";